import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBell = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.23612 13.9999C6.70621 14.4148 7.3237 14.6666 8 14.6666C8.6763 14.6666 9.2938 14.4148 9.76389 13.9999M12 5.33325C12 4.27239 11.5786 3.25497 10.8284 2.50482C10.0783 1.75468 9.06087 1.33325 8 1.33325C6.93914 1.33325 5.92172 1.75468 5.17158 2.50482C4.42143 3.25497 4 4.27239 4 5.33325C4 7.39337 3.48032 8.80389 2.89978 9.73686C2.41009 10.5238 2.16524 10.9173 2.17422 11.0271C2.18416 11.1486 2.20991 11.195 2.30785 11.2676C2.39631 11.3333 2.79506 11.3333 3.59257 11.3333H12.4074C13.2049 11.3333 13.6037 11.3333 13.6922 11.2676C13.7901 11.195 13.8158 11.1486 13.8258 11.0271C13.8348 10.9173 13.5899 10.5238 13.1002 9.73686C12.5197 8.80389 12 7.39338 12 5.33325Z",
		stroke: "white",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgBell;
